import React from "react";
import CustomerService from "services/customer";

import { connect } from "react-redux";
import { load } from "reducers/customer";

class Customer extends React.Component {
  customerService = new CustomerService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.customerService
      .getAll()
      .then(({ data }) => this.props.load(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { load })(Customer);
